import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { bgStyles, borderStyles, flexStyles, pointerStyles, squareStyles } from "ui";

type Props = ComponentProps["FormattingToolbar"]["Button"];
export function Button({ icon, isSelected, onClick, className, children, mainTooltip }: Props) {
  return (
    <button
      className={classNames(
        squareStyles.square200,
        bgStyles.neutral200,
        flexStyles.horiz,
        flexStyles.justifyCenter,
        flexStyles.alignCenter,
        borderStyles.neutral400,
        borderStyles.radius025,
        pointerStyles.cursor,
        { [bgStyles.secondary200]: isSelected },
        className,
      )}
      type="button"
      onClick={onClick}
      title={mainTooltip}
    >
      {icon}
      {children}
    </button>
  );
}
